import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { DsButtonVariants, Icons, DsTooltipPosition } from '@levelaccess/design-system';

import { chain, Dictionary, keyBy } from 'lodash';
import { NavService } from '../../../../services/navigation/nav.service';
import { INavMenuItem, NavigationItem } from '../../../../services/navigation/nav-structure';
import { SharedCommonUtility } from '../../../../../../shared/utils/common.utility';
import { ExternalLinkService } from '../../../../services/external-link.service';

@Component({
  selector: 'top-navbar-control-hub-dropdown',
  templateUrl: './top-navbar-control-hub-dropdown.component.html',
  standalone: false,
})
export class TopNavbarControlHubDropdownComponent implements OnInit {
  public Icons: typeof Icons;
  public DsButtonVariants: typeof DsButtonVariants;
  public DsTooltipPosition: typeof DsTooltipPosition;

  public menuItems$: Observable<INavMenuItem[]>;
  public currentActiveMenuItem$: Observable<INavMenuItem>;

  constructor(
    private navService: NavService,
    private externalLinkService: ExternalLinkService,
  ) {
    this.Icons = Icons;
    this.DsButtonVariants = DsButtonVariants;
    this.DsTooltipPosition = DsTooltipPosition;
  }

  ngOnInit(): void {
    const navItems: Partial<INavMenuItem>[] = [
      { id: NavigationItem.level_ci },
      { id: NavigationItem.evaluations },
      { id: NavigationItem.organization_settings, iconName: Icons.Gear },
      {
        id: NavigationItem.tools_and_integrations,
        label: 'tools_and_integrations_navigation_item_label',
        iconName: Icons.Wrench,
      },
      { id: NavigationItem.administration },
      { id: NavigationItem.internal_use_only },
    ];
    const navItemIds: NavigationItem[] = navItems.map((item: Partial<INavMenuItem>) => item.id);
    const navItemsMap: Dictionary<Partial<INavMenuItem>> = keyBy(navItems, 'id');
    this.menuItems$ = this.navService.getTopLevelMenuItems$(navItemIds).pipe(
      map((items: INavMenuItem[]): INavMenuItem[] =>
        chain(items)
          .filter((item: INavMenuItem) => item?.isAvailable)
          .sortBy((item: INavMenuItem) => navItemIds.indexOf(item.id))
          .map((item: INavMenuItem) => ({
            ...item,
            ...navItemsMap[item.id],
            routerLink: SharedCommonUtility.notNullish(item.externalLinkFn)
              ? item.externalLinkFn(this.externalLinkService)
              : item.routerLink,
          }))
          .value(),
      ),
    );

    this.currentActiveMenuItem$ = this.navService.activeTopLevelMenuItem$();
  }
}
